import { ENDPOINTS } from "@constants";
import AbstractService from "./AbstractService";
import FeatureFlagService from "./FeatureFlagService";
import NexusService from "./NexusService";

export default class InstantPayService extends AbstractService {
	static instantPayEndpoint = ENDPOINTS.instantPay;

	static instantPayApi = NexusService.instantPayApi;

	static instantPayFeature = "use_api_core_endpoints_instant_pay";

	static getInstantPayEligibility(jobId, officerId) {

		if(FeatureFlagService.isEnabled(this.instantPayFeature)) {
			const request = {
				jobId,
				officerId
			}
			return this.instantPayApi.checkEligibility(request)
				.then((response) => ({ data: response }));
		}

		return this.get({
			endpoint: `${this.instantPayEndpoint}/${jobId}?officerId=${officerId}`,
		});
	}
}
